import {
  SET_AVAILABLE_BUSINESS_OWNERS,
  SET_BUSINESS_OWNER
} from 'constants/businessOwner';

const initialState = {
  selectedBusinessOwner: {},
  availableBusinessOwners: []
};

const businessOwnerReducer = (state = initialState, action) => {
  if (action.type === SET_BUSINESS_OWNER) {
    {
      return { ...state, selectedBusinessOwner: action.businessOwner };
    }
  } else if (action.type === SET_AVAILABLE_BUSINESS_OWNERS) {
    return { ...state, availableBusinessOwners: action.businessOwners };
  }

  return state;
};

export default businessOwnerReducer;
